import { ActionTree } from 'vuex';
import axios from 'axios';

import { ApiResponse } from '../../models/app-configuration';
import { GenericBaseParameter } from '../../models/base-parameter';
import { UserParameterModel, IUserListingModel } from '../../models/user';
import { IUserState } from './user-states.store';
import { default as StoreTypes } from '../types';
import UserStoreTypes from './user-types.store';
import { userUri } from '../../common';
import { APICONFIG_LANGUAGE_ID, LOCALSTORAGE_LANG, LOCALSTORAGE_BASE_ICON_RESOURCE_URL, APICONFIG_HEADER_LANGUAGE, PASSWORD_TYPES, 
    APICONFIG_HEADER_MASTER_USER,
    APICONFIG_HEADER_MASTER_PASSWORD,
    LOCALSTORAGE_MASTER_USER,
    getUserRightConfirmMessage,
    LOCALSTORAGE_MASTER_PASS
 } from '../../common/constants';
import { LanguageHelper } from '../../utils/language-helper';
import VueI18n from 'vue-i18n';
import { IUserconfiguration } from '../../models/user-configuration/user-configuration';
import { deepClone } from 'fast-json-patch/lib/core';
import { localizeMessageHanlder } from "../../i18n";

import UserRightConfirm from "../../components/modal-dialog/inner-modal-dialog/user-right-confirm";
import { IAuthConfigModel } from '../../models/user/auth-config.model';
import { LocalStorageAuthorizationData } from '../../utils/authorization/localstorage-authorization-data';



const actions = <ActionTree<IUserState, any>>{
    [UserStoreTypes.Get.LIST_OF_USERS]:
        async ({ getters, commit }, params: GenericBaseParameter<UserParameterModel>) => {

            return getters.service.select(params, userUri.default)
                .then((response: ApiResponse) => {
                    if (response.isSuccess) {
                        commit(UserStoreTypes.Set.LIST_OF_USERS, response.data.items);
                        commit(StoreTypes.Set.PAGINATION, response.data.pagination);
                    }
                    // else
                    //     commit(StoreTypes.Set.ERROR_MSG, response.message);
                });
        }
    , [UserStoreTypes.Get.LIST_OF_USERS_LOOKUP]:
        async ({ getters, commit }, params: GenericBaseParameter<UserParameterModel>) => {
            if (getters.listOfUsers !== null) {
                return Promise.resolve(getters.listOfUsers)
            }
            return getters.service.listOfUsers(params, userUri.default)
                .then((listOfUsers: IUserListingModel[]) => {
                    commit(UserStoreTypes.Set.LIST_OF_USERS, listOfUsers);
                    return Promise.resolve(listOfUsers)
                })
                .catch(ex => {
                    console.log(ex);
                    return Promise.reject(ex);
                });
        }
    , [UserStoreTypes.Get.LIST_OF_USERS_BY_IDNAME]:
        async ({ getters, commit }, params: GenericBaseParameter<UserParameterModel>) => {
            console.log(UserStoreTypes.Get.LIST_OF_USERS_BY_IDNAME);
            if (getters.listOfUsers) return Promise.resolve(getters.listOfUsers);
            return getters.service.select(params, userUri.managers)
                .then((response: ApiResponse) => {
                    if (response.isSuccess) {
                        commit(UserStoreTypes.Set.LIST_OF_USERS, response.data);
                        return response.data;
                    }
                    return [];
                    // else {
                    //     commit(StoreTypes.Set.ERROR_MSG, response.message);
                    // }
                });
        }
    , [UserStoreTypes.Get.AUTH_CONFIG]:
        async ({ getters, commit }, i18n: VueI18n) => {

            if(getters.authConfig)
            {
                return Promise.resolve(getters.authConfig)
            }

            return getters.service.select(null, userUri.authConfig)
                .then((response: ApiResponse) => {
                    if (response.isSuccess) {
                        let langLocalWebApp = localStorage.getItem(LOCALSTORAGE_LANG);

                        let langCode = window['webViewLang'] ? LanguageHelper.convertToI18nLangCode(window['webViewLang'])
                            : langLocalWebApp ? langLocalWebApp : LanguageHelper.convertToLanguage(parseInt(response.data.Config[APICONFIG_LANGUAGE_ID]));

                        const i18nLangCode = i18n.locale;
                        axios.defaults.headers.common[APICONFIG_HEADER_LANGUAGE] = langCode.substring(0, 2)
                            .toLocaleUpperCase();
                        localStorage.setItem(LOCALSTORAGE_LANG, langCode);
                        localStorage.setItem(LOCALSTORAGE_BASE_ICON_RESOURCE_URL, response.data && response.data.BaseIconResourceUrl);
                        if (langCode !== i18nLangCode) {
                            localizeMessageHanlder(langCode);
                        }
                        i18n.locale = langCode;
                        
                        const authData: IAuthConfigModel = response.data;
                        authData.IsMasterUser = false; // default value
                        authData.IsMasterPassword = false; // default value
                        console.log('authData.PasswordType: ' + authData.PasswordType);
                        if (authData.PasswordType && authData.PasswordType !== PASSWORD_TYPES.NORMAL) {
                            const authorizationStorage = new LocalStorageAuthorizationData();
                            const cachedUserRightSelect = authorizationStorage.getAuthDataByKey(LOCALSTORAGE_MASTER_USER);
                            authData.IsMasterPassword = true;
                            axios.defaults.headers.common[APICONFIG_HEADER_MASTER_PASSWORD] = true;
                            if (cachedUserRightSelect !== undefined) {
                                authData.IsMasterUser = cachedUserRightSelect;
                                axios.defaults.headers.common[APICONFIG_HEADER_MASTER_USER] = cachedUserRightSelect;
                                commit(UserStoreTypes.Set.AUTH_CONFIG, authData);
                                return Promise.resolve(authData);
                            }
                            let node = document.createElement('div')
                            document.querySelector('body').appendChild(node)
                            const confirmModal = new UserRightConfirm({
                                i18n: i18n,
                                propsData: {
                                    messages: getUserRightConfirmMessage(authData.UserInfo.Name, authData.Config.LanguageID)
                                }
                            }).$mount(node);
                            return new Promise(resolve => {
                                confirmModal.$on('confirm', ({ isLoginFullRight }) => {
                                    const elm = confirmModal.$el;
                                    confirmModal.$destroy();
                                    confirmModal.$off();
                                    elm?.remove();
                                    authorizationStorage.updateAuthorization(LOCALSTORAGE_MASTER_USER, isLoginFullRight);
                                    authorizationStorage.updateAuthorization(LOCALSTORAGE_MASTER_PASS, true);

                                    axios.defaults.headers.common[APICONFIG_HEADER_MASTER_PASSWORD] = true;

                                    if (isLoginFullRight) {
                                        authData.IsMasterUser = true;
                                        axios.defaults.headers.common[APICONFIG_HEADER_MASTER_USER] = true;
                                        commit(UserStoreTypes.Set.AUTH_CONFIG, authData);
                                        return resolve(authData);
                                    }

                                    axios.defaults.headers.common[APICONFIG_HEADER_MASTER_USER] = false;
                                    commit(UserStoreTypes.Set.AUTH_CONFIG, authData);
                                    return resolve(authData);
                                })
                            })
                        } else {
                            commit(UserStoreTypes.Set.AUTH_CONFIG, authData);
                            return Promise.resolve(authData);
                        }
                    }
                    else{
                        return Promise.reject(null);
                    }
                });
        }
    , [UserStoreTypes.Set.USER_CONFIG]:
        async ({ getters }, data: any) => {
            getters.service.UpdateUserConfigAsync(data, userUri.configs)
                .then((response: ApiResponse) => {
                    return Promise.resolve(response)
                })
                .catch(ex => {
                    return Promise.reject(ex);
                });
        },
    [UserStoreTypes.Set.UPDATE_USER_CONFIG]: ({ commit }, payload: { keyChain: string, value: any }) => {
        commit(UserStoreTypes.Set.UPDATE_USER_CONFIG, payload);
    },
    [UserStoreTypes.Get.USER_INFO]: ({ getters, commit }, id: number) => {
        return getters.service.getUserInformation(id.toString())
            .then((response: IUserconfiguration) => {
                commit(UserStoreTypes.Set.USER_INFO, deepClone(response));
                commit(UserStoreTypes.Set.USER_INFO_ORIGINAL, deepClone(response));
                return Promise.resolve(response);
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    },
    [UserStoreTypes.Set.UPDATE_USER_INFO]: ({ getters, commit }) => {
        return getters.service.upadteUserInformation(getters.userInfoOriginal, getters.userInfo)
            .then((response: IUserconfiguration) => {
                commit('common/setNotificationMessage', { type: 'success', action: 'M_EDIT_NEW', module: 'USER_INFORMATION' }, { root: true });
                commit(UserStoreTypes.Set.USER_INFO_ORIGINAL, deepClone(getters.userInfoOriginal));
                return Promise.resolve(response);
            })
            .catch(ex => {
                // console.log(ex);
                // if (ex.errorCode !== -1000) { 
                //     commit('common/setNotificationMessage', { type: 'error', action: 'M_EDIT_NEW', module: 'USER_INFORMATION', message: ex.data.msg }, { root: true })
                // }
                return Promise.reject(ex);
            })
    },
    [UserStoreTypes.Get.USER_CONFIGURATION]: ({ getters, commit }) => {
        return getters.service.getUserConfiguration()
            .then((response) => {
                commit(UserStoreTypes.Set.USER_CONFIGURATION, deepClone(response));
                commit(UserStoreTypes.Set.USER_CONFIGURATION_ORIGINAL, deepClone(response));
                return Promise.resolve(response);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            })
    },
    [UserStoreTypes.Set.UPDATE_USER_CONFIGURATION]: ({ getters, commit }) => {
        return getters.service.updateUserConfiguration(getters.accountConfigurationOriginal, getters.accountConfig)
            .then((response) => {
                commit('common/setNotificationMessage', { type: 'success', action: 'M_EDIT_NEW', module: 'USER_INFORMATION' }, { root: true });
                commit(UserStoreTypes.Set.USER_CONFIGURATION_ORIGINAL, deepClone(getters.accountConfig));
                return Promise.resolve(response);
            })
            .catch(ex => {
                console.log(ex);
                if (ex.errorCode !== -1000) {
                    commit('common/setNotificationMessage', { type: 'error', action: 'M_EDIT_NEW', module: 'USER_INFORMATION', message: ex.data.msg }, { root: true })
                }
                return Promise.reject(ex);
            })
    },
    [UserStoreTypes.Get.TWO_FACTOR]: ({ getters, commit }) => {
        return getters.service.getTwoFactorLoginConfig()
            .then((response) => {
                commit(UserStoreTypes.Set.TWO_FACTOR, deepClone(response));
                commit(UserStoreTypes.Set.TWO_FACTOR_ORIGINAL, deepClone(response));
                return Promise.resolve(response);
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    },
    [UserStoreTypes.Get.GENERATE_QR_CODE]: ({ getters, commit }, isNew: boolean) => {
        return getters.service.generateQRCode(isNew)
            .then((response) => {
                return Promise.resolve(response);
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    },
    [UserStoreTypes.Get.VERIFY_QR_CODE]: ({ getters, commit }, payload) => {
        return getters.service.verifyQRCode(payload)
            .then((response) => {
                commit('common/setNotificationMessage', { type: 'success', action: 'CONFIRMATION', module: 'USER_OMNICASA_CODE' }, { root: true });
                return Promise.resolve(response);
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    },
    [UserStoreTypes.Set.UPDATE_TWO_FACTOR_CONFIG]: ({ getters, commit }) => {
        const entity = deepClone(getters.twoFactorConfig);
        const original = deepClone(getters.twoFactorConfigOriginal);
        original.Id = entity.UserId;
        entity.Id = entity.UserId;
        return getters.service.upadteUserInformation(original, entity)
            .then((response) => {
                commit('common/setNotificationMessage', { type: 'success', action: 'M_EDIT_NEW', module: 'USER_INFORMATION' }, { root: true });
                commit(UserStoreTypes.Set.TWO_FACTOR_ORIGINAL, deepClone(getters.twoFactorConfig));
                return Promise.resolve(response);
            })
            .catch(ex => {
                console.log(ex);
                if (ex.errorCode !== -1000) {
                    commit('common/setNotificationMessage', { type: 'error', action: 'M_EDIT_NEW', module: 'USER_INFORMATION', message: ex.data.msg }, { root: true })
                }
                return Promise.reject(ex);
            })
    },
    [UserStoreTypes.Set.COPY_AGENDA_CONFIG]: ({ getters, commit }, payload) => {
        return getters.service.copyAgendaConfig(payload)
            .then((response) => {
                return Promise.resolve(response);
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    },

    [UserStoreTypes.Set.USER_CHANGE_PASSWORD]: ({getters, commit}, {userId, requestModel} ) => {
        return getters.service.changePasswordUser(userId, requestModel)
            .then((response) => {
                commit('common/setNotificationMessage', { type: 'success', action: 'M_EDIT_NEW', module: 'CHANGE_PASSWORD' }, { root: true });
                return Promise.resolve(response);
            })
            .catch(ex => {
                if (ex.errorCode !== -1000) {
                    commit('common/setNotificationMessage', { type: 'error', action: 'M_EDIT_NEW', module: 'CHANGE_PASSWORD', message: ex.data.msg }, { root: true })
                }
                return Promise.reject(ex);
            })
    },
    [UserStoreTypes.Get.USER_NOTIFICATION_CONFIG]: ({ getters, commit }) => {
        return getters.service.getUserNotificationConfiguration()
            .then((response) => {
                commit(UserStoreTypes.Set.NOTIFICATION_CONFIG, deepClone(response));
                commit(UserStoreTypes.Set.NOTIFICATION_CONFIG_ORIGINAL, deepClone(response));
                return Promise.resolve(response);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            })
    },
    [UserStoreTypes.Set.UPDATE_NOTIFICATION_CONFIG]: ({ getters, commit }) => {
        const entity = deepClone(getters.notificationConfig);
        const original = deepClone(getters.notificationConfigOriginal);
        return getters.service.upadteNotificationConfig(original, entity)
            .then((response) => {
                commit('common/setNotificationMessage', { type: 'success', action: 'M_EDIT_NEW', module: 'USER_INFORMATION' }, { root: true });
                commit(UserStoreTypes.Set.NOTIFICATION_CONFIG_ORIGINAL, deepClone(getters.notificationConfig));
                return Promise.resolve(response);
            })
            .catch(ex => {
                console.log(ex);
                if (ex.errorCode !== -1000) {
                    commit('common/setNotificationMessage', { type: 'error', action: 'M_EDIT_NEW', module: 'USER_INFORMATION', message: ex.data.msg }, { root: true })
                }
                return Promise.reject(ex);
            })
    },
    [UserStoreTypes.Get.GET_COMPANIES_LIST]: ({ getters }, {apiKey}) => {
        return getters.service.getCompaniesList(apiKey)
            .then((response) => {
                return Promise.resolve(response);
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    },

    [UserStoreTypes.Set.REGISTER_REAL_ESTATE_AGENT]:({ getters }, {requestModel})=>{
        return getters.service.registerRealEstateAgent(requestModel)
            .then((response) => {
                return Promise.resolve(response);
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    },

    [UserStoreTypes.Set.USER_CONFIGURATION_ES]:({ getters }, {requestModel})=>{
        return getters.service.userConfigurationES(requestModel)
            .then((response) => {
                return Promise.resolve(response);
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    },

    [UserStoreTypes.Set.ENABLE_USER_CONFIGURATION_ES]:({ getters }, {requestModel})=>{
        return getters.service.enableUserConfigurationES(requestModel)
            .then((response) => {
                return Promise.resolve(response);
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    },

    [UserStoreTypes.Set.USER_GENERATE_TOKEN]:({ getters }, {requestModel})=>{
        return getters.service.userGenerateToken(requestModel)
            .then((response) => {
                return Promise.resolve(response);
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    },

    [UserStoreTypes.Get.USER_PREPARE_REGISTER_ACCOUNT]: ({ getters }, {email}) => {
        return getters.service.userPrepareRegisterAccount(email)
            .then((response) => {
                return Promise.resolve(response);
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    },

    [UserStoreTypes.Set.USER_APPLY_REGISTER_ACCOUNT]:({ getters }, {requestModel})=>{
        return getters.service.userApplyRegisterAccount(requestModel)
            .then((response) => {
                return Promise.resolve(response);
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    },

    [UserStoreTypes.Get.GET_BUSINESS_LIST]: ({ getters }, {apiKey}) => {
        return getters.service.getBusinessList(apiKey)
            .then((response) => {
                return Promise.resolve(response);
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    },

    [UserStoreTypes.Set.SET_BG_COLOR_SUBSTATUS]:({ getters }, {requestModel})=>{
        return getters.service.configurationColorSubStatus(requestModel)
            .then((response) => {
                return Promise.resolve(response);
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    },
    [UserStoreTypes.Get.USER_RIGHTS]: ({ getters, commit }) => {
        return getters.service.getUserRights()
            .then((response) => {
                commit(UserStoreTypes.Set.USER_RIGHTS, deepClone(response));
                return Promise.resolve(response);
            })
            .catch(ex => {
                return Promise.reject(ex);
            })
    },
    [UserStoreTypes.Set.USER_CONFIGURATION_SEE_AGENDA]:({getters},params) => {
        return getters.service.configurationSeeAgenda(params)
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch(ex => {
            return Promise.reject(ex);
        })
    }
}
export default actions;